import { render } from "./AppTab.vue?vue&type=template&id=442bb34c"
import script from "./AppTab.vue?vue&type=script&lang=js"
export * from "./AppTab.vue?vue&type=script&lang=js"

import "./AppTab.vue?vue&type=style&index=0&id=442bb34c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__